import { render, staticRenderFns } from "./index.vue?vue&type=template&id=877b0538&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=877b0538&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=877b0538&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877b0538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('877b0538')) {
      api.createRecord('877b0538', component.options)
    } else {
      api.reload('877b0538', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=877b0538&scoped=true", function () {
      api.rerender('877b0538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/Withdrawal/index.vue"
export default component.exports